﻿import { PopupMenu } from "./popupMenu";
import { Navigation } from "./navigation";
import { IMenuItem, MenuItemType } from "./menuItemBase";
import { Key } from "ts-keycode-enum";

export class MenubarItem implements IMenuItem{
    public type: MenuItemType = "MenuBarItem";
    public domNode: HTMLElement;
    public menu: Navigation;
    private flag: boolean = false;
    public hasFocus: boolean = false;
    public hasHover: boolean = false;
    public popupMenu: PopupMenu | null = null;

    private handleKeydown(event: KeyboardEvent) {
        //? event.keyCode is depreciated but required for IE11 support
        switch (event.keyCode) {
            case Key.Space:
            case Key.Enter:
            case Key.DownArrow:

                if (this.popupMenu) {
                    this.popupMenu.Open();
                    this.popupMenu.SetFocusToFirstItem();
                    this.flag = true;
                }
                break;

            case Key.LeftArrow:

                this.menu.SetFocusToPreviousItem(this);
                this.flag = true;
                break;

            case Key.RightArrow:

                this.menu.SetFocusToNextItem(this);
                this.flag = true;
                break;

            case Key.UpArrow:

                if (this.popupMenu) {
                    this.popupMenu.Open();
                    this.popupMenu.SetFocusToLastItem();
                    this.flag = true;
                }
                this.flag = true;
                break;

            case Key.Home:
            case Key.PageUp:

                this.menu.SetFocusToFirstItem();
                this.flag = true;
                break;

            case Key.End:
            case Key.PageDown:

                this.menu.SetFocusToLastItem();
                this.flag = true;
                break;

            case Key.Tab:
                this.flag = false;
                this.popupMenu?.Close(true);

                break;

            case Key.Escape:
                this.popupMenu?.Close(true);

                break;

            default:
                break;
        }
        if (this.flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    private handleFocus() {
        this.menu.hasFocus = true;
    }

    private handleBlur() {
        this.menu.hasFocus = false;
        if (this.popupMenu) {
            setTimeout(this.popupMenu.Close.bind(this.popupMenu, false), 400);
        }
    }

    private handleMouseover() {
        this.hasHover = true;
        if (this.popupMenu) {
            this.popupMenu.Open();
        }
    }

    private handleMouseout() {
        this.hasHover = false;
        if (this.popupMenu) {
            setTimeout(this.popupMenu.Close.bind(this.popupMenu, false), 400);
        }
    }

    public SetExpanded(value: boolean) {
        if (value) {
            this.domNode.setAttribute("aria-expanded", "true");
        } else {
            this.domNode.setAttribute("aria-expanded", "false");
        }
    }

    constructor(domNode: HTMLElement, menuObj: Navigation) {
        this.domNode = domNode;
        this.menu = menuObj;
        this.domNode.tabIndex = -1;

        this.domNode.addEventListener("keydown", this.handleKeydown.bind(this));
        this.domNode.addEventListener("focus", this.handleFocus.bind(this));
        this.domNode.addEventListener("blur", this.handleBlur.bind(this));
        this.domNode.addEventListener(
            "mouseover",
            this.handleMouseover.bind(this)
        );
        this.domNode.addEventListener(
            "mouseout",
            this.handleMouseout.bind(this)
        );

        // Initialize pop up menus
        const nextElement: HTMLElement = <HTMLElement>this.domNode.nextElementSibling;

        if (nextElement?.tagName === "UL") {
            this.popupMenu = new PopupMenu(nextElement, this, "Vertical");
        }
    }
}
